import React, {PureComponent} from 'react';
import SCModalCore from '../../../../components/feedback/scModalCore';
import fetchHandler from '../../../../fetch/fetchHandler';
import { getUserList } from '../../../../fetch/fetchApi'; //示例api
import PropTypes from 'prop-types';
import TransferForm from '../forms/transferForm';
import AsyncContent from "../contents/asyncContent";

class TransferModal extends PureComponent{
  constructor (props) {
    super();
    this.props = props;
  }

  componentWillMount () {
    this.content = (
      <div>
        <AsyncContent/>
        <TransferForm modalSubmit={this.onSubmit.bind(this)}/>
      </div>
    );
    this.setState({
      modalConfig: {
        key: 'transferModal',
        width: 600, // 自定义模态框宽度
        title: '带穿梭框的示例', // 模态窗口的标题
        content: this.content, // 自定义 jsx内容
      }
    });
  }

  /*
  * param {object} 表单中的参数，可以和transfer等其他组件的参数assign来进行提交
  * loadedFuc {func} 来自表单中传递的按钮结束加载状态的事件
  * */

  onSubmit (param) {
    // 在隐藏footer的前提下，采用表单的内置按钮提交事件
    return fetchHandler(getUserList, param).then((res) => {
      // TODO(这里执行modal提交callback事件)
      return res;
    });
  }

  render () {
    return <SCModalCore config={this.state.modalConfig} />
  }
}

export default TransferModal;

TransferModal.propTypes = {
  modalState: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/modal/transferModal.js